export const standardError = 'Sorry, something went wrong!';
